<template>
  <div class="tabs">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="报增" name="add"></el-tab-pane>
      <el-tab-pane label="报减" name="reduction"></el-tab-pane>
      <el-tab-pane label="首次缴费名单" name="firstPaymentList2"></el-tab-pane>
      <el-tab-pane label="在保人员" name="underGuarantee2"></el-tab-pane>
      <el-tab-pane label="缴费名单" name="paymentList2"></el-tab-pane>
      <el-tab-pane label="商保提交记录" name="submitList"></el-tab-pane>
      <!-- <el-tab-pane label="失效人员" name="lapse"></el-tab-pane>
      <el-tab-pane label="保险明细" name="onWork"></el-tab-pane>
      <el-tab-pane label="报案理赔" name="settlementClaims"></el-tab-pane>
      <el-tab-pane label="保费账单" name="premiumBill"></el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
  import xz from "../../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        activeName: 'add',
      }
    },
    created() {
      this.activeName = localStorage.getItem("insureActive");
    },
    methods: {
      checkPermission,
      handleClick() {
        if (this.activeName == 'add' || this.activeName == 'reduction') {
          if (window.location.pathname == '/examine') {
            localStorage.setItem("insureActive", this.activeName)
            this.$emit('changeType', this.activeName)
          } else {
            localStorage.setItem("insureActive", this.activeName)
            this.$router.push({
              path: '/examine',
              query: {
                type: this.activeName
              }
            })
          }
        } 
        // else if (this.activeName == 'underGuarantee' || this.activeName == 'lapse') {
        //   if (window.location.pathname == '/underGuarantee') {
        //     localStorage.setItem("insureActive", this.activeName)
        //     this.$emit('changeType', this.activeName)
        //   } else {
        //     localStorage.setItem("insureActive", this.activeName)
        //     this.$router.push({
        //       path: '/underGuarantee',
        //       query: {
        //         type: this.activeName
        //       }
        //     })
        //   }
        // } 
        else {
          localStorage.setItem("insureActive", this.activeName)
          this.$router.push({
            path: this.activeName,
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
<style>

</style>